export default __webpack_public_path__ + "static/media/Tik-idea.1afade08.svg";